// extracted by mini-css-extract-plugin
export var lightMode = "_1a-0";